var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2071 8.54289C18.5976 8.93342 18.5976 9.56658 18.2071 9.95711L12.7071 15.4571C12.3166 15.8476 11.6834 15.8476 11.2929 15.4571L5.79289 9.95711C5.40237 9.56658 5.40237 8.93342 5.79289 8.54289C6.18342 8.15237 6.81658 8.15237 7.20711 8.54289L12 13.3358L16.7929 8.54289C17.1834 8.15237 17.8166 8.15237 18.2071 8.54289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChevronDown);
export default __webpack_public_path__ + "static/media/line-chevron-down.7156b9d24747970c7f931325662ed5aa.svg";
export { ForwardRef as ReactComponent };